import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/index.css";

const BUILD_ID = process.env.REACT_APP_BUILD_ID || "local-dev";
const PRODUCT_ID = "scope-change-shield";

window.SCOPE_CHANGE_SHIELD_BUILD = {
  productId: PRODUCT_ID,
  buildId: BUILD_ID,
  createdAt: new Date().toISOString(),
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
